import { useState, useEffect } from 'react';
import { JOKI, useService } from '../../JOKI';

export function useAlerts(activeOnly = false) {
    const [data, trigger] = useService('AlertsService');
    const [alerts, setAlerts] = useState('LOADING');

    useEffect(() => {
        setAlerts(data !== null ? data : 'LOADING');

        trigger({
            to: 'AlertsService',
            key: activeOnly ? 'getActiveAlerts' : 'getAlerts',
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        return JOKI.on({
            from: 'AlertsService',
            key: 'serviceUpdate',
            fn: event => {
                setAlerts(event.body);
            },
        });
    }, []);

    return [alerts];
}
